module.exports = __webpack_public_path__ + "static/media/feature_4_2.55c3d5e4.jpg";